
import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import Arrow from 'react-native-vector-icons/Feather';
import { featureStyles } from '../styles/features';
import { homestyles } from '../styles/Home';
import { RestaurantCard } from './RestaurantCard';

export const Feature = ({ title, description }) => {
  return (
    <View>
      <View style={featureStyles.container}>
        <Text style={homestyles.font2}>{title} </Text>
        <Arrow name="arrow-right-circle" style={featureStyles.arrow} />
      </View>
      <Text style={featureStyles.descText}>{description} </Text>

      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={featureStyles.imageContainer}>
        <RestaurantCard />
        <RestaurantCard />
        <RestaurantCard />
      </ScrollView>
    </View>
  );
};

export default Feature;
